import { FormattedMessage } from 'react-intl';
import { Button, Text } from 'tombac';
import { ForwardIcon } from 'tombac-icons';
import { LoginForm } from "./LoginForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginPopup = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: "LoginPopup LoginPopup__modal",
    "data-sentry-component": "LoginPopup",
    "data-sentry-source-file": "LoginPopup.tsx",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "LoginPopup__form",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "LoginPopup__title",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "auth.login.title",
          "data-sentry-element": "FormattedMessage",
          "data-sentry-source-file": "LoginPopup.tsx",
          "data-sentry-element": "FormattedMessage"
        })
      }), /*#__PURE__*/_jsx(LoginForm, {
        "data-sentry-element": "LoginForm",
        "data-sentry-source-file": "LoginPopup.tsx",
        "data-sentry-element": "LoginForm"
      }), /*#__PURE__*/_jsxs("div", {
        className: "LoginPopup__contact",
        children: [/*#__PURE__*/_jsx("div", {
          className: "LoginPopup__contact-title",
          children: "Do you have questions about TomTom MOVE products?"
        }), /*#__PURE__*/_jsxs(Text, {
          as: "p",
          variant: "secondary",
          $marginTop: "1sp",
          "data-sentry-element": "Text",
          "data-sentry-source-file": "LoginPopup.tsx",
          "data-sentry-element": "Text",
          children: ["Contact us at", ' ', /*#__PURE__*/_jsx(Text, {
            as: "a",
            href: "mailto:movesupport@tomtom.com",
            $display: "inline-block",
            fontWeight: "bold",
            variant: "interactive",
            "data-sentry-element": "Text",
            "data-sentry-source-file": "LoginPopup.tsx",
            "data-sentry-element": "Text",
            children: "movesupport@tomtom.com"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "LoginPopup__footer",
      children: /*#__PURE__*/_jsxs("div", {
        className: "LoginPopup__footer-content",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "LoginPopup__not-a-customer",
          children: "How well do you understand traffic?"
        }), /*#__PURE__*/_jsx("p", {
          className: "LoginPopup__footer-text",
          children: "TomTom helps traffic planners, authorities, businesses, and drivers manage and predict congestion. TomTom traffic analytics delivers insights into both live and historical traffic data that improves traffic management and mobility."
        }), /*#__PURE__*/_jsx("p", {
          className: "LoginPopup__footer-text",
          children: "Check out our suite of traffic mobility products!"
        }), /*#__PURE__*/_jsx("div", {
          className: "LoginPopup__link",
          children: /*#__PURE__*/_jsx(Button, {
            append: /*#__PURE__*/_jsx(ForwardIcon, {}),
            appendedHoverEffect: "anim-forward",
            as: "a",
            className: "LoginPopup__link-button",
            href: "https://www.tomtom.com/products/tomtom-move/",
            target: "_blank",
            variant: "primary",
            "data-sentry-element": "Button",
            "data-sentry-source-file": "LoginPopup.tsx",
            "data-sentry-element": "Button",
            children: "Go to products"
          })
        })]
      })
    })]
  });
};
export default LoginPopup;